(function () {
    'use strict';

    angular
        .module('app.login')
        .controller('LoginController', LoginController);

    /* @ngInject */
    function LoginController($q, dataservice, logger, loginServices, $uibModalInstance, $stateParams) {
        var vm = this;
        vm.forgetPassword = false ;
        vm.title = 'Login';
        vm.isCPhone = false ;
        vm.fName = false ;
        vm.alert=null; /*message alert*/
        vm.login={}; /*email, password, remember*/
        vm.sendPassword={};/*Email*/

        vm.cId = $stateParams.cId;

        vm.signIn = signIn;
        vm.forgetPasswordFunction = forgetPasswordFunction;


        activate();

        function activate() {
            var promises = []; //
            return $q.all(promises).then(function() {
                // logger.info('Activated Login View');
            });
        }
        function signIn(){
            vm.alert="";
            return loginServices.signIn(vm.login, vm.cId)
                .then(function(data){
               if(data && (data.isCPhone === true  || data.fName === true) ){
                 if(data && data.isCPhone === true){
                       console.log(data,'in controller');
                     vm.isCPhone = data.isCPhone;
                 }
                  if (data &&  data.fName === true ) {
                     vm.fName = data.fName;
             }
               }
              else{
                console.log('no cphone');
              closeModalOrShowAlert(data);
               }



                });
        }

          function setIsCphone (data){

          vm.isCPhone = data;
        }

        // function signIn(){
        //     vm.alert="";
        //     return loginServices.signIn(vm.login.email, vm.login.password, vm.cId)
        //         .then(closeModalOrShowAlert)
        //         .catch(function(data){
        //             vm.alert = data;
        //         });
        //
        // }

        function closeModalOrShowAlert(data){
          console.log(data,'response connection');
            if(data && (!data.error || data.error === 0)){
                vm.login={}; /*email, password, remember*/
                $uibModalInstance.close({error: 0, message: "Connected"});
            }else{
                vm.alert = data ? data.body : 'empty response received';
            }
            return data;
        }
        vm.forgetPasswordActive = function (){
          vm.isCPhone = false ;
          vm.fName = false ;
          vm.forgetPassword = !vm.forgetPassword
        }
        function forgetPasswordFunction() {
            vm.alert="";
//            vm.sendPassword={};/*Email*/
       console.log( vm.sendPassword ,'before');
            if(vm.isCPhone === false){
              delete vm.sendPassword.isCPhone;
            }
            if(vm.fName === false){
              delete vm.sendPassword.fName;
            }
            console.log( vm.sendPassword ,'after');
            return dataservice.login.sendPassword(vm.clinicId, vm.sendPassword )
                .then(function (data) {
                  if(data && (data.isCPhone === true || data.fName === true)){
                      console.log(data,'in controller');
                    if(data.isCPhone === true){
                    vm.isCPhone = true;
                    }
                    if(data.fName === true){
                    vm.fName = true;
                    }

                  }
                  else {
                    console.log(data ,'send password response');
                      vm.login = data;
                      $uibModalInstance.close({error: 0, message: data.body});
                      return data;
                  }

            });

        }
    }
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/login/login.controller.js
 ** module id = 227
 ** module chunks = 0
 **/